export const formatEnglishTitleCase = (
  text: string,
  language?: string,
): string => {
  if (!language?.toLowerCase().startsWith('en')) {
    return text;
  }

  return text.replace(/\S+/g, word => {
    const firstLetterIndex = word.search(/[A-Za-z]/);

    if (firstLetterIndex === -1) {
      return word;
    }

    return `${word.slice(0, firstLetterIndex)}${word
      .charAt(firstLetterIndex)
      .toUpperCase()}${word.slice(firstLetterIndex + 1)}`;
  });
};
